import { 
  FacebookOutlined, 
  TwitterOutlined, 
  InstagramOutlined, 
  LinkedinOutlined, 
  MailOutlined, 
  PhoneOutlined, 
  EnvironmentOutlined 
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* 🌿 About Us */}
        <div className="footer-section">
          <h3>About Us</h3>
          <p style={{ textAlign: "justify" }}>
            At <strong>Garvana Enterprise</strong>, we specialize in{" "}
            <strong>
              landscaping, garden transformation, and eco-friendly outdoor solutions
            </strong>. Our expert team creates{" "}
            <strong>
              customized, sustainable, and visually appealing green spaces
            </strong>{" "}
            for homes, businesses, and urban areas. We turn outdoor dreams into
            reality with creativity, technology, and environmental responsibility.
          </p>
        </div>

        {/* ⚡ Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/products">Our Products</Link></li>
          </ul>
        </div>

        {/* 📞 Contact Info */}
        <div className="footer-section">
          <h3>Contact Us</h3>
          <p>
            <EnvironmentOutlined className="icon" /> Garvana, Vill - Manota, Hasanpur Road, Gajraula,
            Amroha, Uttar Pradesh 244241
          </p>
          <p><PhoneOutlined className="icon" /> +91-9800040505</p>
          <p><MailOutlined className="icon" /> garvana2112@gmail.com</p>
        </div>

        {/* 🌐 Social Media */}
        <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FacebookOutlined /></a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><TwitterOutlined /></a>
            <a href="https://www.instagram.com/garvaana.in?igsh=MWVjaTFpbWx6ZXE5Zg==" target="_blank" rel="noopener noreferrer"><InstagramOutlined /></a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><LinkedinOutlined /></a>
          </div>
        </div>
      </div>

      {/* 🧾 Copyright */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Garvana Enterprise. All Rights Reserved.</p>
      </div>
    </footer>
  );
}
